import { MappingProblemType } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const mappingProblemTypeDictionary = createSimpleDictionary([
    { id: MappingProblemType.TeamOpponentMismatch, name: 'dictionaries.mappingProblemType.teamOpponentMismatch' },
    { id: MappingProblemType.TeamsSwapped, name: 'dictionaries.mappingProblemType.teamsSwapped' },
    { id: MappingProblemType.SameTeamOnBothSides, name: 'dictionaries.mappingProblemType.sameTeamOnBothSides' },
    { id: MappingProblemType.LeagueMismatch, name: 'dictionaries.mappingProblemType.leagueMismatch' },
]);
